<template>
  <div class="neg-filtros">
    <div class="row items-center q-gutter-sm">
      <q-chip
        clickable
        :color="!negociosFiltros.etapa_id ? 'secondary' : 'grey-3'"
        :text-color="!negociosFiltros.etapa_id ? 'white' : 'grey-8'"
        @click="filtrarPorEtapa(null)"
      >
        Todas
      </q-chip>
      <q-chip
        v-for="etapa in negociosEtapas"
        :key="etapa.id"
        clickable
        :color="negociosFiltros.etapa_id === etapa.id ? 'secondary' : 'grey-3'"
        :text-color="negociosFiltros.etapa_id === etapa.id ? 'white' : 'grey-8'"
        @click="filtrarPorEtapa(etapa.id)"
      >
        {{ etapa.nome }}
      </q-chip>

      <q-chip
        clickable
        icon="filter_list"
        :color="negociosFiltrosExtrasAtivos > 0 ? 'secondary' : 'grey-3'"
        :text-color="negociosFiltrosExtrasAtivos > 0 ? 'white' : 'grey-8'"
        @click="painelAberto = !painelAberto"
      >
        Mais filtros{{ negociosFiltrosExtrasAtivos ? " (" + negociosFiltrosExtrasAtivos + ")" : "" }}
      </q-chip>

      <q-btn
        flat
        round
        dense
        color="primary"
        :icon="negociosView === 'quadro' ? 'view_list' : 'view_kanban'"
        @click="$emit('alternar-view')"
      >
        <q-tooltip>{{ negociosView === "quadro" ? "Ver como lista" : "Ver como quadro" }}</q-tooltip>
      </q-btn>

      <q-space />

      <q-input
        dense
        clearable
        debounce="300"
        class="neg-busca"
        placeholder="Cliente, código ou protocolo"
        :model-value="negociosFiltros.busca"
        @update:model-value="buscar"
      >
        <template v-slot:prepend>
          <q-icon name="search" />
        </template>
      </q-input>

      <q-btn
        v-if="temFiltro"
        flat
        dense
        no-caps
        color="primary"
        label="Limpar filtros"
        @click="limpar"
      />
    </div>

    <div v-show="painelAberto" class="neg-painel">
      <q-select
        dense
        clearable
        emit-value
        map-options
        label="Linha"
        option-value="id"
        option-label="nome"
        :options="negociosLinhas"
        :model-value="negociosFiltros.linha_id"
        @update:model-value="aplicar({ linha_id: $event })"
      />

      <q-select
        dense
        clearable
        emit-value
        map-options
        label="Operador"
        option-value="id"
        option-label="label"
        :options="negociosFuncionarios"
        :model-value="negociosFiltros.funcionario_id"
        @update:model-value="aplicar({ funcionario_id: $event })"
      />

      <negocios-campo-data
        label="Aberta a partir de"
        :value="negociosFiltros.dtini"
        @input="aplicar({ dtini: $event })"
      />

      <negocios-campo-data
        label="Aberta até"
        :value="negociosFiltros.dtfim"
        @input="aplicar({ dtfim: $event })"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import negociosMixin from "@/mixins/negocios";

export default {
  name: "negocios-filtros",

  emits: ["alternar-view", "limpar", "mudou"],
  mixins: [negociosMixin],
  data() {
    return {
      painelAberto: false
    };
  },
  computed: {
    ...mapGetters([
      "negociosFiltros",
      "negociosEtapas",
      "negociosLinhas",
      "negociosFuncionarios",
      "negociosFiltrosExtrasAtivos",
      "negociosView"
    ]),
    temFiltro() {
      return Boolean(this.negociosFiltros.busca) || Boolean(this.negociosFiltros.etapa_id) ||
        this.negociosFiltrosExtrasAtivos > 0;
    }
  },
  methods: {
    aplicar(filtros) {
      this.$store.commit("negociosFiltros", filtros);
      this.$emit("mudou");
    },
    filtrarPorEtapa(etapaId) {
      this.aplicar({ etapa_id: etapaId });
    },
    buscar(termo) {
      this.aplicar({ busca: termo || null });
    },
    limpar() {
      this.painelAberto = false;
      this.$emit("limpar");
    }
  }
};
</script>
